import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../../components/base/PageLayout';

export default function Sitemap() {
  useEffect(() => {
    document.title = 'サイトマップ - 執事ベル オフィシャルサイト全ページ一覧｜執事ベル';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '執事ベル オフィシャルサイトのサイトマップ。プロフィール、執事の知恵（おもてなしの心・フォーマルマナー・執事スキル・日常の品格）、各種記事、サービス案内（企業研修・マナー講座・プライベート執事・コンサルティング）、メディア掲載実績、お問い合わせなど、サイト内の全ページを一覧でご確認いただけます。');
    }

    // Add Keywords meta tag
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'サイトマップ, ページ一覧, サイト構造, ナビゲーション, 全ページ');
    } else {
      const keywordsTag = document.createElement('meta');
      keywordsTag.name = 'keywords';
      keywordsTag.content = 'サイトマップ, ページ一覧, サイト構造, ナビゲーション, 全ページ';
      document.head.appendChild(keywordsTag);
    }

    // Add Canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', `${import.meta.env.VITE_SITE_URL || "https://butlerbell.jp"}/sitemap`);
    } else {
      const canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.href = `${import.meta.env.VITE_SITE_URL || "https://butlerbell.jp"}/sitemap`;
      document.head.appendChild(canonical);
    }

    // Add Last-modified
    const lastModified = document.querySelector('meta[name="last-modified"]');
    if (lastModified) {
      lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);
    } else {
      const lastModTag = document.createElement('meta');
      lastModTag.name = 'last-modified';
      lastModTag.content = new Date().toISOString().split('T')[0];
      document.head.appendChild(lastModTag);
    }

  }, []);

  const siteStructure = [
    {
      title: 'メインページ',
      pages: [
        { name: 'トップページ', href: '/', description: '執事ベルのオフィシャルサイトトップ' },
        { name: '執事ベルについて', href: '/about', description: '詳細プロフィール・経歴・理念' },
        { name: '『執事のマナーと教養図鑑』', href: '/book/butler-manners-and-culture', description: '執事ベル監修書籍の紹介・書誌情報' },
        { name: 'お問い合わせ', href: '/contact', description: 'サービスに関するご質問・ご依頼' },
        { name: 'メディア掲載', href: '/media', description: '各種メディアでの紹介実績' }
      ]
    },
    {
      title: '執事の知恵',
      pages: [
        { name: '執事の知恵トップ', href: '/wisdom', description: 'カテゴリー一覧・記事検索' },
        { name: 'おもてなしの心', href: '/wisdom/hospitality', description: '相手を思いやる心とサービス精神' },
        { name: 'フォーマルマナー', href: '/wisdom/etiquette', description: '社交の場で輝くエチケット' },
        { name: '執事スキル', href: '/wisdom/butler-skills', description: 'プロフェッショナルとしての技術' },
        { name: '日常の品格', href: '/wisdom/elegance', description: '日々の所作に宿る美しい生き方' }
      ]
    },
    {
      title: '記事詳細',
      pages: [
        { name: 'VIP対応の極意', href: '/wisdom/articles/vip-service', description: '一流ホテルで培ったVIPゲスト対応の真髄' },
        { name: 'コミュニケーション術', href: '/wisdom/articles/communication', description: '心に響く会話とコミュニケーション技術' },
        { name: 'おもてなしの心構え', href: '/wisdom/articles/mindset', description: 'サービス精神の本質と実践方法' },
        { name: 'テーブルマナーの美学', href: '/wisdom/articles/table-manners', description: 'フォーマルディナーで輝くマナー' },
        { name: 'ドレスコードの基本', href: '/wisdom/articles/dress-code', description: '場面に応じた適切な装い' },
        { name: '社交のエチケット', href: '/wisdom/articles/social-etiquette', description: 'パーティーや会合でのマナー' },
        { name: '執事の一日', href: '/wisdom/articles/daily-routine', description: 'プロフェッショナルの日常ルーティン' },
        { name: '観察力の磨き方', href: '/wisdom/articles/observation', description: '相手のニーズを察知する技術' },
        { name: '時間管理の技術', href: '/wisdom/articles/time-management', description: '効率的で優雅な時間の使い方' },
        { name: '美しい所作', href: '/wisdom/articles/posture', description: '品格ある立ち居振る舞い' },
        { name: '言葉遣いと話し方', href: '/wisdom/articles/speech', description: '相手に敬意を示す言葉の技術' },
        { name: '整理整頓の哲学', href: '/wisdom/articles/organization', description: '美しい空間作りの原則' },
        { name: '電話応対の第一声を整える作法', href: '/wisdom/columns/telephone-first-greeting', description: '第一声で信頼を得る電話応対の作法' },
        { name: '手土産の選び方と渡し方の作法', href: '/wisdom/columns/temiyage-selection-and-presentation', description: '相手に喜ばれる手土産の選定と渡し方' }
      ]
    },
    {
      title: 'サービス',
      pages: [
        { name: 'サービス一覧', href: '/services', description: '提供サービスの概要' },
        { name: '企業研修・セミナー', href: '/services/corporate-training', description: 'おもてなしとマナーの企業研修' },
        { name: 'プライベート執事サービス', href: '/services/private-butler', description: '特別な日を完璧に演出' },
        { name: 'マナー講座', href: '/services/manner-course', description: '個人・グループ向けマナー教育' },
        { name: 'コンサルティング', href: '/services/consulting', description: 'ホスピタリティ向上の専門アドバイス' }
      ]
    },
    {
      title: 'その他',
      pages: [
        { name: 'プライバシーポリシー', href: '/privacy', description: '個人情報の取り扱いについて' },
        { name: '特定商取引法に基づく表記', href: '/legal', description: '法的事項・利用規約' },
        { name: 'サイトマップ', href: '/sitemap', description: 'サイト全体の構造・ページ一覧' }
      ]
    }
  ];

  return (
    <PageLayout hero={<>
<section className="py-32 bg-gradient-to-br from-[#1a1a1a] via-[#2a2a2a] to-[#1a1a1a]">
        <div className="max-w-7xl mx-auto px-8 text-center">
          <h1 
            className="text-3xl md:text-5xl font-light text-white mb-8 tracking-wide"
            style={{ fontFamily: '"Noto Serif JP", serif' }}
          >
            サイトマップ
          </h1>
          <p 
            className="text-xl md:text-2xl text-amber-400 font-light tracking-wider"
            style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
          >
            サイト全体の構造とページ一覧
          </p>
        </div>
      </section>
</>}>
      {/* Hero Section */}
      

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-8">
          <div className="mb-12 text-center">
            <p 
              className="text-lg text-gray-700 leading-relaxed max-w-6xl mx-auto"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              執事ベルのオフィシャルサイトの全ページをカテゴリー別にご案内いたします。<br />
              お探しの情報やサービスがございましたら、以下のリンクからお進みください。
            </p>
          </div>

          <div className="space-y-16">
            {siteStructure.map((section, index) => (
              <div key={index} className="bg-[#f5f5f5] rounded-lg p-8">
                <h2 
                  className="text-3xl font-medium text-[#1a1a1a] mb-8 text-center"
                  style={{ fontFamily: '"Noto Serif JP", serif' }}
                >
                  {section.title}
                </h2>
                
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {section.pages.map((page, pageIndex) => (
                    <Link
                      key={pageIndex}
                      to={page.href}
                      className="group bg-white rounded-lg p-6 shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer border border-gray-100 hover:border-[#917c50]/30"
                    >
                      <div className="flex items-start space-x-3">
                        <div className="w-2 h-2 bg-[#917c50] rounded-full mt-2 flex-shrink-0 group-hover:bg-[#b8975f] transition-colors duration-300"></div>
                        <div className="flex-1">
                          <h3 
                            className="text-lg font-medium text-[#1a1a1a] mb-2 group-hover:text-[#917c50] transition-colors duration-300"
                            style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                          >
                            {page.name}
                          </h3>
                          <p 
                            className="text-sm text-gray-600 leading-relaxed"
                            style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                          >
                            {page.description}
                          </p>
                          <div className="mt-3 flex items-center text-[#917c50] text-sm group-hover:text-[#b8975f] transition-colors duration-300">
                            <span>詳細を見る</span>
                            <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform duration-300"></i>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Statistics */}
          <div className="mt-20 bg-gradient-to-r from-[#917c50] to-[#b8975f] rounded-lg p-8 text-center">
            <h3 
              className="text-2xl font-medium text-white mb-6"
              style={{ fontFamily: '"Noto Serif JP", serif' }}
            >
              サイト統計
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div>
                <div 
                  className="text-3xl font-bold text-white mb-2"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  29
                </div>
                <div 
                  className="text-white/90 text-sm"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  総ページ数
                </div>
              </div>
              <div>
                <div 
                  className="text-3xl font-bold text-white mb-2"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  12
                </div>
                <div 
                  className="text-white/90 text-sm"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  執事の知恵記事
                </div>
              </div>
              <div>
                <div 
                  className="text-3xl font-bold text-white mb-2"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  4
                </div>
                <div 
                  className="text-white/90 text-sm"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  サービス詳細
                </div>
              </div>
              <div>
                <div 
                  className="text-3xl font-bold text-white mb-2"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  4
                </div>
                <div 
                  className="text-white/90 text-sm"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  知恵カテゴリー
                </div>
              </div>
            </div>
          </div>

          {/* Contact CTA */}
          <div className="mt-16 text-center">
            <h3 
              className="text-2xl font-medium text-[#1a1a1a] mb-6"
              style={{ fontFamily: '"Noto Serif JP", serif' }}
            >
              お探しの情報が見つからない場合
            </h3>
            <p 
              className="text-gray-700 mb-8"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              ご不明な点やご質問がございましたら、お気軽にお問い合わせください。
            </p>
            <Link
              to="/contact"
              className="inline-block bg-[#917c50] text-white px-8 py-3 rounded font-medium hover:bg-[#7a6642] transition-all duration-300 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              お問い合わせフォームへ
            </Link>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
